
import * as Action from "./Action";
const initial_state = {
    zones:[],
    tasks:[]
}
const store = (store=initial_state,action) =>{
             switch(action.type){
                 case(Action.ADD_ZONE):
                     localStorage.setItem("zones",JSON.stringify(store.zones.concat(action.land)))
                     return {
                           ...store,
                           zones:store.zones.concat(action.land)
                       }
                 case(Action.ADD_PLOT):
                        const index = action.zindex;
                        const copyZone = store.zones;
                        const zone = copyZone[index];
                        const zonePlot = zone.plots
                        zonePlot.push(action.plot)
                        zone.plots = zonePlot
                        copyZone[index] = zone;
                        localStorage.setItem("zones",JSON.stringify(copyZone))
                        return {
                            ...store,
                            zones:copyZone
                        }      
                  case(Action.ADD_CROPLAND):
                        const pcopyZone = store.zones;
                        const pzone = pcopyZone[action.zindex];
                        const plot = pzone.plots[action.pindex];
                        plot.cropsland.push(action.crop)
                        pzone.plots[action.pindex] = plot
                        pcopyZone[action.zindex] = pzone
                        localStorage.setItem("zones",JSON.stringify(pcopyZone))
                        return {
                            ...store,
                            zones:pcopyZone
                        }  
                  case(Action.DELETE_ZONE):
                     let uuid = action.id 
                     const filtered = store.zones.filter(z=>{
                         return z.id !== uuid
                     });
                     localStorage.setItem("zones",JSON.stringify(filtered))
                     return {
                       ...store,
                       zones:filtered
                     } 
                 case(Action.DELETE_PLOT):
                    const cstore = store.zones
                    let zindex = action.zindex
                    let id = action.id;
                    const pdcopyZone = cstore[zindex]
                    const filteredPlots = pdcopyZone.plots.filter(p=>{
                        return p.id !== id
                    })
                    pdcopyZone.plots = filteredPlots
                    cstore[zindex] = pdcopyZone
                    localStorage.setItem("zones",JSON.stringify(cstore))
                    return {
                    ...store,
                    zones:cstore
                    } 
                  case(Action.DELETE_CROPLAND):
                    const clstore = store.zones;
                    const zIndex = action.zindex;
                    const pIndex = action.pindex;
                    const iD = action.id;
                    const clcopyZone = clstore[zIndex]; 
                    const plotcopy = clcopyZone.plots[pIndex];
                    const clfilteredPlots = plotcopy.cropsland.filter(p=>{
                        return p.id !== iD
                    });
                    clcopyZone.plots[pIndex].cropsland = clfilteredPlots;
                    clstore[zIndex] = clcopyZone
                    localStorage.setItem("zones",JSON.stringify(clstore))
                    return {
                    ...store,
                    zones:clstore
                    }              
                  case(Action.ADD_TASK): 
                    const combinedTask = store.tasks.concat([action.task]) 
                    localStorage.setItem("tasks",JSON.stringify(combinedTask))  
                    return {
                        ...store,
                        tasks:combinedTask
                    }
                  case(Action.FETCH_TASK_FROM_LOCAL_STORAGE):
                        const local_task = localStorage.getItem("tasks")
                        if(local_task){
                            const parsedTask = JSON.parse(local_task)
                            return {
                                ...store,
                                tasks:store.tasks.concat(parsedTask)
    
                            }  
                        }
                        return {
                            ...store,

                        }  

                  case(Action.FETCH_FROM_LOCAL_STORAGE):
                     const local_items = localStorage.getItem("zones")
                     if(local_items){
                         const parsedItem = JSON.parse(local_items)
                        return {
                            ...store,
                            zones:store.zones.concat(parsedItem)

                        }
                     }         
                     return {
                         ...store
                     }
                 case(Action.UPDATE_TASK):
                     const alltask = store.tasks
                     const task = {...alltask[action.index]}
                     task.taskname = action.name 
                     alltask[action.index] = task
                     localStorage.setItem("tasks",JSON.stringify(alltask))
                     return{
                         ...store,
                         tasks:alltask
                     }

                 default:
                     return store
             }
}

export default store